/**
 * ホーミングモード発動時の視覚エフェクトの状態更新および描画（HUNTER専用機能）
 *
 * プレイヤー周囲のオーラなどの演出を管理します。
 *
 * @module effects/homing-effects
 */

import { getP5 } from '../../core/p5-instance';
import {
    getHomingActive,
    getPlayer
} from '../../store';

/**
 * ホーミングエフェクトに付随する動的な状態を更新します。
 * 現在はタイマー管理のみですが、将来的に拡張（揺れやパーティクル生成など）するために用意されています。
 */
export function updateHomingEffect(): void {
    // 現状は特別な視覚状態更新はなし（必要に応じて追加）
}

/**
 * ホーミングモードのエフェクト（オーラなど）を画面に描画します。
 * 注意: この関数は現在の状態に基づいて描画のみを行い、数値の更新は行いません。
 */
export function renderHomingEffect(): void {
    const p = getP5();
    const homingActive = getHomingActive();
    const player = getPlayer();

    if (!homingActive || !player) {
        return;
    }

    // プレイヤー周囲のホーミングオーラ演出
    const homingPulse = p.sin(p.frameCount * 0.15) * 0.3 + 0.7;
    p.push();
    p.noFill();
    p.stroke(255, 150, 0, 100 * homingPulse);
    p.strokeWeight(2);
    p.circle(player.x, player.y, player.size * 1.6);

    // 補助的な発光の環
    p.stroke(255, 200, 50, 50 * homingPulse);
    p.strokeWeight(1);
    p.circle(player.x, player.y, player.size * 1.8 + p.sin(p.frameCount * 0.1) * 5);
    p.pop();
}
